import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const renderContent = (message, type)=>{
    return React.Children.map(message, (m, index)=>/*#__PURE__*/ React.createElement("p", {
            className: "alert__message",
            key: `alert--${type}--${index}`
        }, m)
    );
};
/**
 *
 * @param {'info' | 'success' | 'error' | 'warning'} [type] - Determines which type of alert to render.
 * @param {React.ReactNode} [message] - alert message. If array of elements is passed, each will be wrapped individually in a \<p\> tag.
 * @param {string} [icon] - Which icon to use. Must be a valid icon name for the <Icon /> component.
 * @param {string} [title] - Bolded line of text serving as the alert title. Can only contain plain text.
 * @param {className} [string] - Class name to be added to the root node of the component
 * @param {notifyScreenReader} [boolean] - When 'true', the text within the Alert component will be announced for screenreader users when it is rendered on the page. Use this for dynamic updates, such as error and status messages. Do NOT use it for static content that doesn't change or update. Defaults to false
 * @param {titleHeadingLevel} [string] - Determines which HTML text element is used for the Title section. Defaults to h3
 * @returns
 */ const Alert = (_param)=>{
    var { type ='info' , message , icon , title , children , className , notifyScreenReader , titleHeadingLevel ='h3'  } = _param, attr = swcHelpers.objectWithoutProperties(_param, [
        "type",
        "message",
        "icon",
        "title",
        "children",
        "className",
        "notifyScreenReader",
        "titleHeadingLevel"
    ]);
    if (!children && !message && !title) {
        return null;
    }
    const classes = classnames(`alert`, `alert--${type}`, className, {
        'alert--with-icon': icon
    });
    // If notifyScreenReader is defined, always use that value. Otherwise, check if 'type' equals 'error'
    const shouldNotifySR = notifyScreenReader !== undefined ? notifyScreenReader : type === 'error';
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, attr, {
        className: classes,
        "data-t": `alert-${type}`,
        role: shouldNotifySR ? 'alert' : undefined
    }), icon && /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        className: "alert__icon"
    }), title && /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading1",
        component: titleHeadingLevel,
        className: "alert__title"
    }, title), message && renderContent(message, type), children && /*#__PURE__*/ React.createElement("div", {
        className: "alert__children"
    }, children));
};
var Alert$1 = Alert;

export { Alert$1 as default };
//# sourceMappingURL=Alert.js.map
